const firebaseConfig = {
    apiKey: "AIzaSyB790_XNv2t-BgK5xVFoGoFINESbaZ65pU",
    authDomain: "assignment-10-72373.firebaseapp.com",
    projectId: "assignment-10-72373",
    storageBucket: "assignment-10-72373.appspot.com",
    messagingSenderId: "711776866434",
    appId: "1:711776866434:web:95f7d0fb24b6fe8fb8e49b"
  };
  export default firebaseConfig;